<div id="orGlobalAdministrationUsers">
  <mat-form-field>
    <input matInput placeholder="Search users" #input data-cy="search-user-input">
  </mat-form-field>

  <mat-card class='mat-elevation-z8 job-information-card'>
    <ng-container>

      @if (dataSource.loading$ | async) {
        <div class="spinner-container">
          <mat-spinner style="margin:0 auto;" mode="indeterminate"></mat-spinner>
        </div>
      }

      <mat-table class="users-table mat-elevation-z8" [dataSource]="dataSource"
                 matSort matSortActive="id" matSortDirection="asc" matSortDisableClear
                 data-cy="users-table">

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header="id">#</mat-header-cell>
          <mat-cell *matCellDef="let user" data-cy="id-cell">{{user.id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="avatar">
          <mat-header-cell *matHeaderCellDef>Avatar</mat-header-cell>
          <mat-cell class="avatar-cell" *matCellDef="let user" data-cy="avatar-cell">
            @if (user.pictureUrl) {
              <img class="or-icon-userpic or-rounded" src="{{user.pictureUrl}}" />
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
          <mat-cell class="name-cell" *matCellDef="let user" data-cy="name-cell">{{user.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="emailAddress">
          <mat-header-cell *matHeaderCellDef mat-sort-header="emailAddress">Email Address</mat-header-cell>
          <mat-cell class="emailAddress-cell" *matCellDef="let user" data-cy="email-address-cell">{{user.emailAddress}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="managingCompany">
          <mat-header-cell *matHeaderCellDef>Managing Company</mat-header-cell>
          <mat-cell class="managingCompany-cell" *matCellDef="let user" data-cy="managing-company-cell">{{getManagingCompanyLabel(user)}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="adminManagingCompanies">
          <mat-header-cell *matHeaderCellDef>Administrator for</mat-header-cell>
          <mat-cell *matCellDef="let user" data-cy="admin-managing-companies-cell">{{ getAdminManagingCompanyLabels(user) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="authMethod">
          <mat-header-cell *matHeaderCellDef>Auth Method</mat-header-cell>
          <mat-cell class="authMethod-cell" *matCellDef="let user" data-cy="auth-method-cell">{{user.authMethod}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="authSource">
          <mat-header-cell *matHeaderCellDef>Auth Source</mat-header-cell>
          <mat-cell class="authSource-cell" *matCellDef="let user" data-cy="auth-source-cell">{{user.authSource}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastLoggedIn">
          <mat-header-cell *matHeaderCellDef>Last logged in</mat-header-cell>
          <mat-cell class="lastLoggedIn-cell" *matCellDef="let user" data-cy="last-logged-in-cell">{{formatLastLoggedIn(user.lastLoggedIn)}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="globalAuthorities">
          <mat-header-cell *matHeaderCellDef>Global Authorities</mat-header-cell>
          <mat-cell class="globalAuthorities-cell" *matCellDef="let user" data-cy="global-authorities-cell">
            @for (globalAuthority of user.globalAuthorities; track globalAuthority) {
              <mat-chip-listbox>
                <mat-chip-option>{{globalAuthority}}</mat-chip-option>
              </mat-chip-listbox>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell class="actions-cell" *matCellDef="let userOutline" data-cy="actions-cell">
            <button mat-mini-fab (click)="editUser(userOutline)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab color="warn" (click)="deleteUser(userOutline)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="dataSource.counter$ | async" [pageSize]="defaultPageSize"
                     [pageSizeOptions]="defaultPageOptions"></mat-paginator>
    </ng-container>
  </mat-card>
</div>